const translationTestHelper = (stringTemplate) => {
  const prefixForTesting = ''
  return `${prefixForTesting}${stringTemplate}`
}

const th = translationTestHelper

export default th
